export const CONVERSION_DISPLAY_VALUE = 200;

export const RANGE_OPTION = {
	min: 1,
	max: 400,
	step: 1,
	defaultValue: 200,
};

export const RANGE_OPTION_SCALE = {
	min: 0.5,
	max: 1.5,
	step: 0.05,
	defaultValue: 1,
};

// 拡大・縮小 0.02
// 広げる・狭める +-4
// 内転・外転
// 上下 4
